import { render, staticRenderFns } from "./ArceRating.vue?vue&type=template&id=f5ee8712&"
import script from "./ArceRating.vue?vue&type=script&lang=js&"
export * from "./ArceRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports